import { render } from "./Search.vue?vue&type=template&id=4026e891"
import script from "./Search.vue?vue&type=script&setup=true&lang=js"
export * from "./Search.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4026e891"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4026e891', __exports__)) {
    api.reload('4026e891', __exports__)
  }
  
  module.hot.accept("./Search.vue?vue&type=template&id=4026e891", () => {
    api.rerender('4026e891', render)
  })

}


export default __exports__